import { render, staticRenderFns } from "./StrapiTableHeader.vue?vue&type=template&id=71ef329a&scoped=true&"
import script from "./StrapiTableHeader.vue?vue&type=script&lang=js&"
export * from "./StrapiTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./StrapiTableHeader.vue?vue&type=style&index=0&id=71ef329a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef329a",
  null
  
)

export default component.exports